// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';


var origin = {
  x: 0.0,
  y: 0.0
};

exports.origin = origin;
/* No side effect */
